import Link from 'next/link';

import GenericSkeleton from 'components/skeleton/GenericSkeleton';
import styles from './DashboardComponentLink.module.css';

interface Props {
  linkText: string;
  href: string;
  target?: string;
  rel?: string;
  loading?: boolean;
}

const DashboardComponentLink = (props: Props) => {
  return (
    <div
      className={styles.container + ` textAlignRight textDecorationUnderline`}
    >
      <Link href={props.href}>
        <a target={props.target} rel={props.rel}>
          {props.loading ? (
            <GenericSkeleton inverseColors width={130} height={24} />
          ) : (
            <strong>{props.linkText}</strong>
          )}
        </a>
      </Link>
    </div>
  );
};

export default DashboardComponentLink;
